<template>
  <v-style spellcheck="false">
    {{ getOptionsCSSCode }}
  </v-style>
</template>
<script>
import Vue from 'vue'
import { getCodeCSSFromOptions } from '@/utils/css-utils'

Vue.component('v-style', {
  render: function (createElement) {
    return createElement('style', this.$slots.default)
  }
});
export default {
  name: 'StyleComponent',
  props: {
    css: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    getOptionsCSSCode () {
      return getCodeCSSFromOptions(this.css, false)
    },
  }
}
</script>
